export default __webpack_public_path__ + "static/media/single-project-page-05-img-11.99f31792.png";